import { InjectionToken } from '@angular/core';

/**
 * Bridge to AngularJS `$filter`.
 *
 * CalendarService formats dates with `$filter('date')(value, format)`. The
 * date filter honours user preferences-driven format strings (e.g. `shortDate`,
 * timezone suffixes) that have no direct Angular 18 equivalent yet. This port
 * keeps the legacy behaviour byte-identical until the formatting layer is
 * migrated.
 */
export type AngularFilterFn = (value: unknown, ...args: unknown[]) => string;

export interface IFilterPort {
  (name: 'date'): AngularFilterFn;
  (name: string): AngularFilterFn;
}

export const FILTER_PORT = new InjectionToken<IFilterPort>('FILTER_PORT');
